import { useState, useEffect } from 'react';
import './Clinica.css';
import { clinicaSlides, clinicaTextos, CAROUSEL_INTERVAL } from '../../constants';

function Clinica() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = clinicaSlides;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, CAROUSEL_INTERVAL);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <section id="clinica" className="clinica-section">
      <div className="clinica-container">
        <div className="clinica-text">
          <h2>{clinicaTextos.titulo}</h2>
          {clinicaTextos.paragrafos.map((paragrafo, index) => (
            <p key={index}>{paragrafo}</p>
          ))}
        </div>

        <div className="carousel-container">
          <div className="carousel-track">
            {slides.map((slide, index) => {
              // Calcula a posição relativa ao slide atual
              let position = index - currentSlide;

              // Normaliza a posição para criar o efeito circular
              if (position < -slides.length / 2) {
                position += slides.length;
              }
              if (position > slides.length / 2) {
                position -= slides.length;
              }

              // Calcula o ângulo para posicionamento circular
              const angle = (position * 360) / slides.length;
              const radius = 180; // raio do círculo
              const x = Math.sin((angle * Math.PI) / 180) * radius;
              const z = Math.cos((angle * Math.PI) / 180) * radius - radius;

              // Define escala e opacidade baseado na posição
              let scale = 1 - Math.abs(position) * 0.2;
              scale = Math.max(scale, 0.6);

              let opacity = 1 - Math.abs(position) * 0.3;
              opacity = Math.max(opacity, 0.3);

              const zIndex = Math.round(10 - Math.abs(z) / 10);

              return (
                <div
                  key={index}
                  className={`carousel-card ${position === 0 ? 'active' : ''}`}
                  style={{
                    transform: `translateX(${x}px) translateZ(${z}px) scale(${scale})`,

                    opacity: opacity,
                    zIndex: zIndex
                  }}
                >
                  <img src={slide.image} alt={`Clínica Gerações ${slide.id}`} className="carousel-image" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Clinica;
